if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.mediaReady = false;
        this.mobileQuery = window.matchMedia('(max-width: 749px)');
      }

      connectedCallback() {
        super.connectedCallback();
        // 桌面端可提前挂载；移动端等首次点击再初始化
        if (!this.mobileQuery.matches) {
          this.ensureMedia();
        }
      }

      ensureMedia() {
        if (this.mediaReady || this.dataset.mediaReady === 'true') {
          this.mediaReady = true;
          return;
        }

        const content = this.querySelector('.product-media-modal__content');
        const template = this.querySelector('template[data-product-modal-media]');
        if (!content || !template) {
          this.mediaReady = true;
          this.dataset.mediaReady = 'true';
          return;
        }

        content.appendChild(template.content.cloneNode(true));
        template.remove();
        this.mediaReady = true;
        this.dataset.mediaReady = 'true';
      }

      hide() {
        super.hide();
      }

      show(opener) {
        this.ensureMedia();
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        if (!this.openedBy) return;

        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        if (!activeMedia) return;

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        if (container) {
          container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
        }

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          activeMedia.loadContent();
        }
      }
    }
  );
}
